import*as o from"react";const l=(null===globalThis||void 0===globalThis?void 0:globalThis.document)?o.useLayoutEffect:()=>{};export{l as useLayoutEffect};
